import { useEffect } from 'react'

const useOnInit = callback => {
  useEffect(() => {
    callback()
    // https://stackoverflow.com/q/62943157/5003128
    // eslint-disable-next-line
  }, [])
}

export default useOnInit
